var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCaseCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 4h10v2H9V4zm0 6h10v2H9v-2zm0 6h10v2H9v-2zM3 5a2 2 0 1 1 3.999-.001A2 2 0 0 1 3 5zm0 6a2 2 0 1 1 3.999-.001A2 2 0 0 1 3 11zm0 6a2 2 0 1 1 3.999-.001A2 2 0 0 1 3 17z"
})));
export default SvgIconCaseCard;